import { Component, OnInit ,OnDestroy} from '@angular/core';
import { Subscription } from 'rxjs';
import { ClassType } from 'src/app/shared/Models/SessionBookingDTO';
import { GuestService } from 'src/app/shared/services/guest.service';
import { ActivitiesService } from '../activities.service';

@Component({
    selector: 'app-rate-plan-details',
    templateUrl: './rate-plan-details.component.html',
    styleUrls: ['./rate-plan-details.component.scss'],
    standalone: false
})
export class RatePlanDetailsComponent implements OnInit, OnDestroy {
  Subscriptions: Subscription = new Subscription();
  ratePlan: any;
  OperationCurrency: any;
  isSessionClass: any;
  constructor(public activityService: GuestService) {
    this.ratePlan = this.activityService.RatePlanList$.value;
    this.Subscriptions.add(
      this.activityService.RatePlanList$.subscribe(data => {
        this.ratePlan = data;
      }));

    this.Subscriptions.add(
      this.activityService.editPartyData$.subscribe(data => {
        this.isSessionClass = data.ClassType === ClassType.Session;
      }));

  }

  ngOnInit(): void {
    this.OperationCurrency = this.activityService.restaurantWidgetSettings$.value.OperationCurrency;
  }
  ngOnDestroy(): void {
    if (this.Subscriptions) { this.Subscriptions.unsubscribe(); }
  }
}
